<template>
    <div class="main-section-wrapper" :class="`${reviewMode ? 'reviewMode' : ''} ${state}`">
      
      <div class="wrapper-of-uploade">
        <div class="flex column gap-10">
          <!-- <div class="text" v-if="sectionFile.documentType == 'kyc-aa-y1-12'"> 
            <div style="text-align: left;">
              Annual Accounts - last two (2) book year
            </div>
          </div> -->
          <div class="header file-name-section">
            <div>{{ headerText }}</div>
            <div class="flex row gap-10 extra-buttons">
              <button class='file-button color-white buttons' style="width: fit-content" @click="doSanctionScreaningShowConfirm" v-if="canDoSanctionScreening">
                Sanction Screaning
              </button>
              <button class='file-button color-white buttons' style="width: fit-content" @click="doGoogleSearch" v-if="canDoGoogleSearch">
                Google Search
              </button>
              <button v-if="organizationalChart" @click="showChart" class="buttons structure-button file-button color-white">
                Chart
              </button>
            </div>
          </div>
          <div class="additinal-info flex row " v-if="yearPresent || fiscal_year_ending_on_present || sectionFile.documentType == 'kyc-gaming-license'">
            <div v-if="yearPresent">
              <InpComponent 
                :pendingChanges="hasChanges('year')"
                type="options"
                :options="yearOptions"  
                :label="year_title"
                :class="`${getInputValue('year', true) ? 'change': ''}`"
                key_ref="year"
                :key="`year-${sectionFile.id}`"
                :disabled="disabled || !canUpload"
                :value="getInputValue('year')" 
                @inputChange="inputChangeFunc"
                :error="year_error"
              />
            </div>
            <div v-if="fiscal_year_ending_on_present" class="date-input">
              <InpComponent 
                :pendingChanges="hasChanges('fiscal_year_ending_on')"
                type="date"
                class="input-fiscal-year"
                label="Fiscal Year Ending On"
                :key="`fiscal_year_ending_on-${sectionFile.id}`"
                key_ref="fiscal_year_ending_on"
                :disabled="disabled || !canUpload"
                :class="`${getInputValue('fiscal_year_ending_on', true) ? 'change': ''}`"
                :value="getInputValue('fiscal_year_ending_on')" 
                @inputChange="inputChangeFunc"
                :error="fiscal_year_ending_on_error"
              />
            </div>
            <div v-if="sectionFile.documentType == 'kyc-gaming-license'">
              <InpComponent 
                :pendingChanges="hasChanges('license_type')"
                type="options"
                :options="[
                  {
                    value: 'B2B',
                    text: 'B2B'
                  },{
                    value: 'B2C',
                    text: 'B2C'
                  }
                ]"  
                label="License Type"
                :key="`license_type-${sectionFile.id}`"

                key_ref="license_type"
                :disabled="disabled || !canUpload"
                :class="`${getInputValue('license_type', true) ? 'change': ''}`"
                :value="getInputValue('license_type')" 
                @inputChange="inputChangeFunc"
              />
            </div>
          </div>
         
        </div>
      </div>
      <div class="flex row gap-20 2-full flex-1">
        <div v-if="issueDatePresent" class="styled-input flex-1" :class="year_error ? 'error-present': ''">
          <InpComponent 
            :pendingChanges="hasChanges('dateIssued')"
            type="date"
            :key="`dateIssued-${sectionFile.id}`"
            :label="dateLabel"
            key_ref="dateIssued"
            :class="`${getInputValue('dateIssued', true) ? 'change': ''}`"
            :disabled="disabled || !canUpload"
            :value="getInputValue('dateIssued')" 
            @inputChange="inputChangeFunc"
            :error="year_error"
          />
        </div>
        <div v-if="['address_file', 'passport_file', 'secondPassport_file'].includes(sectionFile.documentType)" 
          class="flex-1 flex row gap-5"
          
          >
          <InpComponent 
            :pendingChanges="hasChanges('certDate')"
            type="date"
            :key="`certDate-${sectionFile.id}`"
            :label="'Doc/Cert Date '"
            key_ref="certDate"
            :class="`ml-10 ${getInputValue('certDate', true) ? 'change': ''}`"
            :disabled="disabled || !canUpload"
            :value="getInputValue('certDate')" 
            @inputChange="inputChangeFunc"
            :error="year_error"
          />
          <img 
            v-if="!reviewMode"
            src="@/assets/bell.svg" 
            class="info-icon" title="This date is the date on the document/certificate, not the issue date"
            @click="selectPeriodOpen()"
          />
          <div v-if="getInputValue('certNotification')" class="reminder-text p-5" :class="`${getInputValue('certNotification', true) ? 'change': ''}`">
            {{certNotificationMap[getInputValue('certNotification')]}}
          </div>
        </div>
        <div v-if="hasExpirationDate" class="styled-input flex-1">
          <InpComponent 
            :pendingChanges="hasChanges('expiration_date')"
            type="date"
            :key="`expiration_date-${sectionFile.id}`"
            :label="'Expiration Date'"
            key_ref="expiration_date"
            :class="`${getInputValue('expiration_date', true) ? 'change': ''}`"
            :disabled="disabled || !canUpload"
            :value="getInputValue('expiration_date')" 
            @inputChange="inputChangeFunc"
            :error="year_error"
          />

        </div>
      </div>
      <div v-if="banknamePresent" class="styled-input">
        <InpComponent 
          :pendingChanges="hasChanges('bank_name')"
          type="text"
          label="Bank Name"
          key_ref="bank_name"
          :key="`bank_name-${sectionFile.id}`"
          :class="`${getInputValue('bank_name', true) ? 'change': ''}`"
          :disabled="disabled || !canUpload"
          :value="getInputValue('bank_name')" 
          @inputChange="inputChangeFunc"
          :error="year_error"
        />
      </div>
    
      <div
          class="drop-area"
          @dragover.prevent="dragOver"
          @dragleave.prevent="dragLeave"
          @drop.prevent="dropFile"
          @click="canUpload && $refs.fileInput.click()"
          :class="{ 
            'drag-over': isDragOver, 
            'full-width': fullWidth, 
            'canUpload': canUpload,
            'change': fileToShow && fileToShow[state]?.filename,
            'hasChanges': hasChanges('fileInfo'),
          }"
        >
        <div class="upload-section" v-if="canUpload">
          <div class="flex row gap-10 align-center justify-start w-full">
            <button class="flex justify-center transparent button action-buttons file-button">
              <img src="@/assets/pin.svg" class="plus" color="black"/>
                Upload File
            </button>
            <div class="flex-1">or drag & drop</div>

          </div>
        </div>
        <input v-if="canUpload" type="file" ref="fileInput" :accept="acceptedFormats" style="display: none" @change="handleFileChange" />
      </div>

      <div 
        v-if="(fileToShow && fileToShow[state]?.filename) || ((filePresent || selectedFile) &&  !fileToShow)"
        class='current-file-section mt-20' 
        :class="`${hasChanges('fileInfo') ? 'new-changes': ''} ${fileToShow && fileToShow[state]?.filename ? 'change': ''}`" 
        >
        <div class="file-info">
          <div class="label-extension">{{ getExtensionName }}</div>
          <img src="@/assets/file.svg" class="image-upload"/>
        </div>
        <div>
          <div class="flex row justify-center align-center gap-10 has-changes">
            <img v-if="hasChanges('fileInfo')" class="pending-changes" title="Pending changes awaiting approval" src="@/assets/info.svg">
          </div>
          <div class="text-left file-name"> 
              <text v-if="!state || state == 'current'">{{sectionFile.file.filename }} </text>
              <text v-else-if="state">{{fileToShow?.new?.filename || sectionFile.file.filename }}</text>
          </div>

          <div class="more-actions" v-if="filePresent" @click="eventClick">
            <div v-if="download_available" class="action-div" @click="openFile" ><img src="@/assets/password-look.svg"  class="delete">View</div>
            <div v-if="download_available" class="action-div" @click="Download" ><img src="@/assets/download.svg" class="download"> Download</div>
            <div v-if="delete_available" class="action-div" @click="DeleteFileConfirm" ><img src="@/assets/delete.svg" class="delete">Remove</div>
          </div>
        </div>
      </div>
      <div v-else class='current-file-section mt-20 missing-file'
        @dragover.prevent="dragOver"
        @dragleave.prevent="dragLeave"
        @drop.prevent="dropFile"
        @click="canUpload && $refs.fileInput.click()"
      >
        <div class="file-info">
          <img src="@/assets/file.svg" class="image-upload"/>
        </div>
        <div class="text-left file-name"> 
            No file uploaded
          </div>
      </div>



      
      <div class="world-check-info mt-20" v-if="sectionFile.documentType == 'world_check' && detailedView && canWriteSanctionScreeningComments">
      <div class='alert' v-if="!checkmarksConform">Sanction screening findings do not conform.</div>
      <div class="w-full text-left bold f-18 mb-10">{{getUserType}} SECTION</div>
      
      <div class="options flex column gap-10">
        <div class="flex align-start gap-5">
          <div class="option-desctions">
            Sanctions found  
          </div> 
          <Toggle
            :disabled="disabled || reviewMode"
            :value="getCheckmartValue(`sanctions_found${commentPrefix}`)"
            :options="[
                { label: 'Yes', value: 'YES' },
                { label: 'No', value: 'NO' },
            ]"
            @change="(val) => inputChange(`sanctions_found${commentPrefix}`, val)"
          />
        </div>
        <div class="flex align-start gap-5">
          <div class="option-desctions">
            PEP  
          </div> 
          <Toggle
            :disabled="disabled || reviewMode"
            :value="getCheckmartValue(`pep_found${commentPrefix}`)"
            :options="[
                { label: 'Yes', value: 'YES' },
                { label: 'No', value: 'NO' },
            ]"
            @change="(val) => inputChange(`pep_found${commentPrefix}`, val)"
          />
        </div>
        <div class="flex align-start gap-5">
          <div class="option-desctions">
            Relevant Adverse Information  
          </div>
          <Toggle
            :disabled="disabled || reviewMode"
            :value="getCheckmartValue(`relevant_adverse_information_found${commentPrefix}`)"
            :options="[
                { label: 'Yes', value: 'YES' },
                { label: 'No', value: 'NO' },
            ]"
            @change="(val) => inputChange(`relevant_adverse_information_found${commentPrefix}`, val)"
          /> 
        </div>
      </div>
    </div>

    <PopupCover v-if="selectPeriodActive">
      <PopupBody 
         
        class="select-period-popup"
        @close="selectPeriodOpen"> 
        <template #header>
          <span>Select Period Info</span>
        </template>
        <template #body>
          <div class="info-text">
            <InpComponent
              type="options"
              :options="[
                {value: 'none', text: 'No reminder'},
                {value: '30_days', text: '30 Days'},
                {value: '60_days', text: '60 Days'},
                {value: '90_days', text: '90 Days'},
                {value: '120_days', text: '120 Days'},
                {value: '150_days', text: '150 Days'},
                {value: '180_days', text: '180 Days'},
              ]"
              label="Reminder in"
              :pendingChanges="hasChanges('certNotification')"
              key_ref="certNotification"
              :key="`certNotification-${sectionFile.id}`"
              :class="`${getInputValue('certNotification', true) ? 'change': ''}`"
              :disabled="disabled || !canUpload"
              :value="getInputValue('certNotification')" 
              @inputChange="inputChangeFunc"
              :error="year_error"
            />
          </div>
          <div class="flex row gap-10 align-end" v-if="canUpload">
            <button class='transparent w-content ' @click="selectPeriodOpen">
              Cancel
            </button>
            <button class='left-auto w-content ' @click="selectPeriodOpen">
              Confirm
            </button>
          </div>
        </template>
      </PopupBody>
    </PopupCover>

    <PopupCover v-if="deleteObject" @close="() => deleteObject = !deleteObject">
      <ConfirmationPopup 
        @confirm="popupConfirm"
        @cancel="() => deleteObject = !deleteObject"
        :title="'Delete Document '"
        :message="'Are you sure you want to delete this Document?'"
      />
    </PopupCover>
      
    <PopupCover v-if="confirmSanctionScreaning" @close="() => confirmSanctionScreaning = !confirmSanctionScreaning">
      <ConfirmationPopup 
        class="popup-confirm"
        @confirm="doSanctionScreaningRequest"
        @cancel="() => confirmSanctionScreaning = false"
        title='Sanction Screaning Request'
        :message="'Are you sure you want to perform a sanction screaning request? \nThe data provided will be used by third party to find any matches in sanction lists'"
      />
    </PopupCover>
    <PopupCover v-if="sanctionScreeningRequestLoading">
      <div class="container-loading">
          <div class="loader-header">Please Wait</div>
          <div class="loader" >
              <img src="@/assets/web-loader.svg" width="60px" height="60px">
          </div>
          <div class="loader-text">Performing Sanction Screaning...</div>
      </div>
    </PopupCover>
    <PopupCover v-if="showSanctionScreeningPopup">
      <div class="sanction-screanin-response">
      
        <SanctionResponseItem 
          :person_id="person_id"
          :sanctioResponse="sanctionScreaning.data"
          :search_id="sanctionScreaning.search_id"
          :sanctionRequest="sanctionScreaning.request"
          :isPopup="true"
          @close="showSanctionScreeningPopup = false"
        />
      </div>
    </PopupCover>
    <PopupCover v-if="showWorldCheckPopup" @close="handleWorldCheckClose()">
      <PopupBody class='sanction-screening-comment-popup' @close="handleWorldCheckClose()">
        <template #header>
            {{ WorldCheckMapFunction(showWorldCheckPopup) }}
        </template>

        <template #body>
          <div class="world-check-info mb-20 flex column gap-10 align-end">
            <CommentSection 
              :attrId="`${getCommentForType(showWorldCheckPopup)}`" 
              class="markdown-content small"
              :class="{disabled: complienceOfficerDisabled || preview}"
              :disabled="preview"
              :commentSection="sectionFile[`new_${getCommentForType(showWorldCheckPopup)}`] || sectionFile[`${getCommentForType(showWorldCheckPopup)}`]"
              @changeinput="quillContent" 
            />
            <button class='w-content ' @click="handleWorldCheckClose()">
              Confirm
            </button>
          </div>
        </template>
      </PopupBody>
    </PopupCover>

    <PopupCover v-if="showStructure" @close="showStructure = ''">
      <PopupBody 
        class="structure-view"
        @close="() => showStructure = ''"> 
        <template #header>
          <span>
            Corporate 
            <text> Shareholder</text>
            Structure for {{ dashboardSettings.name.new_value || dashboardSettings.name.value }}
          </span>
        </template>
        <template #body>
          <StructureChart 
            :key="'corporatesturcture'"
            :type="showStructure"
            :source="showStructure"
            :name="`Corporate Shareholder Structure for ${ dashboardSettings.name.new_value || dashboardSettings.name.value }`"
            :root="true"
          />
        </template>
      </PopupBody>
    </PopupCover>
  </div>

</template>

<script setup>
import { ref, defineEmits, computed, onMounted } from 'vue'
import InpComponent from '@/components/InpComponent.vue'

import API from '../api/index.js'
import store from '../store';
import PopupCover from './PopupCover.vue'
import ConfirmationPopup from './ConfirmationPopup.vue'
import { PermissionChecker } from '@/utils/iam_utils';
import SanctionResponseItem from '@/components/SanctionResponseItem.vue'
import PopupBody from './PopupBody.vue';
import StructureChart from '@/components/StructureChart.vue';
import Utils from '@/utils/index.js';
import { 
  
  WorldCheckMapFunction,
  getCommentForType

} from '@/utils/sanction_screening.js';

import { new_comments, commentHasContent } from '@/utils/kyc_utils.js';
import CommentSection from '@/views/CommentSection.vue';
import Toggle from '@/elements/Toggle.vue'

const viewingToken = computed(() => store.state.viewingToken);

const selectPeriodActive = ref(false);

const deleteObject = ref(false);

const dueDiligenceRecord = computed(() => store.state.dueDiligenceRecord);
const selectedFile = ref(null)
const props = defineProps([
  'fileId',
  'title', 
  'error', 
  'second_line_normal', 
  'fullWidth',
  'disabled',
  'reviewMode',
  'requestedFile',
  'fileFieldChange',
  'fileToShow',
  'state',
  'person_id',
  'detailedView'
])

const notificationPresent = computed(() => props.reviewMode ?  [] : store.getters.getActionRequired(props.fileId, 'kyc_file'));

const hasChanges = computed(() => (field) => {
  for (const item of notificationPresent.value) {
    let fields = JSON.parse(item.fields); 
    let fileInfo = JSON.parse(item.fileInfo);
    if (item.actionType == 'remove') {
      return true;
    }
    if (field == 'fileInfo') {
    
      if (!fileInfo) {
        return false
      }
      if (fileInfo.new) {
        return true
      }
    }
    if (fields[field]?.new) {
      return true
    }
  
  }
})


const getExtensionName = computed(() => {
  let name = '';
  if (props.fileToShow) {
    let filename = props.fileToShow[props.state]?.filename || sectionFile.value.file.filename;
    if (filename) {
      name = filename.split('.').slice(-1)[0]
    }
  } if (sectionFile.value.file) {
    name =  sectionFile.value.file.filename.split('.').slice(-1)[0]
  }
  return name;
})

const certNotificationMap = {
  'none': 'No reminder',
  '30_days': 'Reminder after 30 Days',
  '60_days': 'Reminder after 60 Days',
  '90_days': 'Reminder after 90 Days',
  '120_days': 'Reminder after 120 Days',
  '150_days': 'Reminder after 150 Days',
  '180_days': 'Reminder after 180 Days',
}

const sectionFile = computed(() => store.getters.getFileById(props.fileId, props.requestedFile));
const subsidiary = computed(() => store.getters.getSubsidiaryById(sectionFile.value.subsidiary_id));
const showWorldCheckPopup = ref(false);
const person = computed(() => store.getters.getPersonById(props.person_id));
const randomId = ref(Math.random().toString(36).substring(7));
const checkmarksConform = computed( () => store.getters.checkmarksConform(props.fileId));

const user = computed(() => store.state.user);

const isChecked = computed(() => (key, value) => {
  return (sectionFile.value[`new_${key}`] || sectionFile.value[key]) == value;
})
const getCheckmartValue = computed(() => (key) => {
  return sectionFile.value[`new_${key}`] || sectionFile.value[key];
})


const getUserType = computed(() => {
  if (user.value.type == 'DATA_CONTROLLER') {
    return 'ACCOUNT MANAGER'
  }
  if (user.value.type == 'DATA_PROCESSOR') {
    return 'SUPERVISOR'
  }
  if (user.value.type == 'COMPLIANCE_OFFICER') {
    return 'COMPLIANCE OFFICER'
  }
})


const filePresent = computed(() => {
  if (sectionFile.value.file) {
    return true;
  }
  if (props.fileToShow) {
    if (props.state == 'current' && !props.fileToShow.current) {
      return false;
    }
    return true;
  }
});


const acceptedFormats = computed( () => {
  if (sectionFile.value.documentType == 'kyc-oc-6') {
    return '.pdf, .png, .jpg, .jpeg'
  }
  return '.pdf'
})


function selectPeriodOpen() {
  selectPeriodActive.value = !selectPeriodActive.value;
}

const getInputValue = (key, fromChange = false) => {
  if (!props.fileFieldChange) {
    if (!fromChange) {
      return sectionFile.value[`new_${key}`] || sectionFile.value[key];
    }
    return null;
  }

  if (!props.fileFieldChange[key]) {
    if (fromChange) {
      return null;
    }
    return null || sectionFile.value[`new_${key}`] || sectionFile.value[key];
  }

  if (!props.fileFieldChange[key][props.state]) {
    return null;
  }

  if (props.state == 'current' && !props.fileFieldChange[key].current) {
    return null;
  }

  return props.fileFieldChange[key][props.state]
}


onMounted(() => {
  if (!props.fileId) {
    throw new Error('fileId is required')
  }
})


const headerText = computed(() => {
  
  if (['scfba', 'cosbaof'].includes(sectionFile.value.documentType)) {
    return `${Utils.typeToName(sectionFile.value.documentType)} for ${sectionFile.value.bank_name || ''}`
  }
  if (sectionFile.value.documentType == 'subsidiaries') {
    return `${subsidiary.value?.name} annual accounts - last book year`
  }
  return Utils.typeToName(sectionFile.value.documentType)
})


const canWriteSanctionScreeningComments = computed(() => {
  return ['DATA_PROCESSOR', 'DATA_CONTROLLER', 'COMPLIANCE_OFFICER'].includes(user.value.type)
})

const commentPrefix = computed( () => store.getters.getWorldCheckEditablePrefix)

const upload_available = computed(() => {
  if (props.reviewMode) {
    return false;
  }
  if (sectionFile.value.dueDiligence) {
    console.log('VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV')
    if (dueDiligenceRecord.value?.status == 'SIGNED') {
      return false;
    }
    return true;
  }
  if (!sectionFile.value.ubo && !sectionFile.value.md && !sectionFile.value.person && !sectionFile.value.legalEntity) {
    console.log('CCCCCCCCC_BBBBBBBBBBBBBBBBBBBBBBBBBBBB')
    
    return PermissionChecker.uploadFileCorporate()
  }
  if (!sectionFile.value.md && sectionFile.value.person) {
    return PermissionChecker.updateUBOSection()
  }
  if (sectionFile.value.md) {
    return PermissionChecker.updatembdSection()
  }
})

const download_available = computed(() => {
  if (!sectionFile.value.ubo && !sectionFile.value.md && !sectionFile.value.person && !sectionFile.value.legalEntity) {
    return PermissionChecker.downloadCorporate()
  }
  if (!sectionFile.value.md && sectionFile.value.person) {
    return PermissionChecker.downloadUbOSection()
  }
  if (sectionFile.value.md) {
    return PermissionChecker.downloadmbdSection()
  }
})

const delete_available = computed(() => {
  if (props.reviewMode) {
    return false;
  }
  if (!sectionFile.value.ubo && !sectionFile.value.md && !sectionFile.value.person && !sectionFile.value.legalEntity) {
      return PermissionChecker.deleteCorporate()
  }
  if (!sectionFile.value.md && sectionFile.value.person) {
    return PermissionChecker.deleteUBOSectionFiles()
  }
  if (sectionFile.value.md) {
    return PermissionChecker.deletembdSectionFiles()
  }
})


const showStructure = ref('')
const titleParts = computed(() => props.title && props.title.split('\n'));
const isDragOver = ref(false)
const yearOptions = computed(() => store.state.yearOptions);

const dashboardSettings = computed(() => store.state.companyData);

const fiscal_year_ending_on_error = ref('')
const year_error = ref('')
const confirmSanctionScreaning = ref(false);

const sanctionScreaning = ref(null);
const sanctionScreeningResponse = ref(null);
const showSanctionScreeningPopup = ref(false);
const sanctionScreaningRequestInfo = ref(null);
const sanctionScreeningRequestLoading = ref(false);



const banknamePresent = computed(() => {
  return [
    'scfba',
    'cosbaof'
  ].includes(sectionFile.value.documentType)
})

const dateLabel = computed(() => {
  const titleMap = {
    'kyc-feeibtbvdna-3' : 'Issue Date',
    'kyc-lteabibtdoea-4': 'Issue Date',
    'kyc-mlibtdoea-4-1': 'Issue Date',
    'kyc-attaoi-5-1': 'Issue Date',
    'kyc-reftcoc-5-2': 'Incorporation Date',
    'kyc-gaming-license': 'Issue Date',
    'address_file': 'Issue Date',
  }
  return titleMap[sectionFile.value.documentType]
})


const issueDatePresent = computed(() => {
  return [
    'kyc-feeibtbvdna-3',
    'kyc-lteabibtdoea-4',
    'kyc-mlibtdoea-4-1',
    'kyc-attaoi-5-1',
    'kyc-reftcoc-5-2',
    'kyc-gaming-license',
    'address_file'
  ].includes(sectionFile.value.documentType)
})

const hasExpirationDate = computed(() => {
  return [
    'kyc-gaming-license',
  ].includes(sectionFile.value.documentType)
})

const yearPresent = computed(() => {
  return [
    'kyc-aa-y1-12',
    'kyc-aa-y2-12',
    'kyc-dogmos-13',
    'kyc-fpt-14',
    'subsidiaries',
  ].includes(sectionFile.value.documentType)
})

const year_title = computed(() => {
  let year_titles = {
      'kyc-aa-y2-12': 'Year 2',
      'kyc-aa-y1-12': 'Year 1',
      'subsidiaries': 'Annual accounts year',
  }
  return year_titles[sectionFile.value.documentType] || 'Year'
})

const fiscal_year_ending_on_present = computed(() => {
  return [
    'kyc-aa-y1-12',
    'kyc-aa-y2-12',
  ].includes(sectionFile.value.documentType)
})


const organizationalChart = computed(() => {
  return [
    'kyc-oc-6',
  ].includes(sectionFile.value.documentType)
})

const canDoGoogleSearch = computed(() => {
  return (
    sectionFile.value.documentType == 'google_search'
  )
})

const canDoSanctionScreening = computed(() => {
    return (
      sectionFile.value.documentType == 'world_check' && 
      dashboardSettings.value.sanction_screening_available.value == 'YES' && 
      !props.reviewMode &&
      PermissionChecker.canDoSnactionScreaning()
    )
})


function showChart(event) {
  event.stopPropagation();
  showStructure.value = 'shareholder'
}

function doGoogleSearch(event) {
  event.stopPropagation();
  if (!person.value?.firstName.value) {
    store.dispatch('addNotification', {text: 'Please fill First Name field', type: 'error'})
    return;
  }
  if (!person.value?.lastName.value) {
    store.dispatch('addNotification', {text: 'Please fill Last Name field', type: 'error'})
    return;
  }
  
  let link = 'https://www.google.com/search?q='
  
  const firstName = person.value.firstName.new_value || person.value.firstName.value;
  const lastName = person.value.lastName.new_value || person.value.lastName.value;

  link += `${firstName}+${lastName}`;
  // open link in new tab
  window.open(link, '_blank');
} 
function doSanctionScreaningShowConfirm(event) {
  event.stopPropagation();

  let missingFields = [];

  if (!person.value?.firstName.value) {
    missingFields.push('First Name');
  }
  if (!person.value?.lastName.value) {
    missingFields.push('Last Name');
  }
  if (!person.value?.dateOfBirth.value) {
    missingFields.push('Date of Birth');
  }
  if (!person.value?.passportCountry.value) {
    missingFields.push('Nationality');
  }
  if (missingFields.length > 0) {
    const errorText = `Please fill ${missingFields.join(', ')} field${missingFields.length > 1 ? 's' : ''} before using API sanction screening`
    store.dispatch('addNotification', {text: errorText, type: 'error'})
    return;
  }



  confirmSanctionScreaning.value = true;
}
function doSanctionScreaningRequest(){
  confirmSanctionScreaning.value = false;
  sanctionScreaningRequest()
}


async function sanctionScreaningRequest() {
  sanctionScreeningRequestLoading.value = true;
  const response = await API.newDueDiligenceRequest({person_id: props.person_id});

  sanctionScreeningRequestLoading.value = false;
  if (response?.status == 'error' || !response?.data) {
      if (response?.requiredFileds) {
          const errorText = `Please fill ${response.requiredFileds.map(el => fieldNameMap[el]).join(', ')} fields before using API sanction screening`
          store.dispatch('addNotification', {text: errorText, type: 'error'})
      } else {
          store.dispatch('addNotification', {text: response?.message, type: 'error'})
      }
  } else {
      sanctionScreaning.value = response;
      sanctionScreeningResponse.value = response.data;
      sanctionScreaningRequestInfo.value = response.request;
      showSanctionScreeningPopup.value = true;
  }
}

function dragOver() {
  if (!canUpload.value) {
    return;
  }
  isDragOver.value = true;
}
 
const canUpload = computed(() => {
  return upload_available.value
})

const localFiscalYear = ref(sectionFile.value.fiscal_year_ending_on)
const localYear = ref(sectionFile.value.year)

function dragLeave() {
    if (!canUpload.value) {
      return;
    }
    isDragOver.value = false;
}
function dropFile(event) {
    if (!canUpload.value) {
      return;
    }
    isDragOver.value = false;
    handleFileChange(event);
}


function quillContent(event) {
  store.commit('updateFileById',{
    id: props.fileId, 
    updates: {
      [`new_${event.id}`]: event.structure,
    }
  })
}





function handleWorldCheckClose(){
  const new_commentValue = new_comments(sectionFile.value, getCommentForType(showWorldCheckPopup.value))
  const hasContent = commentHasContent(sectionFile.value, getCommentForType(showWorldCheckPopup.value), 'old')
  const hasContentNew = commentHasContent(sectionFile.value, getCommentForType(showWorldCheckPopup.value), 'new')
  let warning = false;

  if (sectionFile.value[`new_${showWorldCheckPopup.value}`] == 'NO') {
    showWorldCheckPopup.value = false;
    return 
  }
  if (!sectionFile.value[`new_${showWorldCheckPopup.value}`] && sectionFile.value[`${showWorldCheckPopup.value}`] == 'NO') {
    showWorldCheckPopup.value = false;
    return
  }
  if (
    (!new_commentValue && !hasContent) || (new_commentValue && !hasContentNew)
  ) {
    warning = true;
  }

  if (warning){
    store.dispatch('addNotification', {
      text: `${WorldCheckMapFunction(showWorldCheckPopup.value)} will be set as NO as there are no comments provided`, type: 'error'
    })
    store.commit('updateFileById',{
      id: props.fileId, 
      updates: {
        [`new_${showWorldCheckPopup.value}`]: 'NO',
      }
    })
  }
  showWorldCheckPopup.value = false;
}


async function inputChange(name, value) {
  if (value == 'YES') {
    showWorldCheckPopup.value = name;
  } 

  store.commit('updateFileById',{
    id: props.fileId, 
    updates: {
      [`new_${name}`]: value,
    }
  })
}

function inputChangeFunc(event) {
    const event_type = event[0];
    const event_value = event[1];
    
    if (['dateIssued', 'license_type','expiration_date', 'bank_name', 'certDate', 'certNotification'].includes(event_type)) {
      store.commit('updateFileById',{
        id: props.fileId, 
        updates: {
          [`new_${event_type}`]: event_value,
        }
      })
    }
    if (event_type == 'year') {
      localYear.value = event_value
    }
    if (event_type == 'fiscal_year_ending_on') {
      localFiscalYear.value = event_value
    }

    let year_val = localYear.value;
    let fiscal_year_ending_on_val = localFiscalYear.value;
    if (year_val && fiscal_year_ending_on_val) {
      if (+year_val > +fiscal_year_ending_on_val.slice(0, 4) &&  +year_val != +fiscal_year_ending_on_val.slice(0, 4)) {
        fiscal_year_ending_on_error.value = 'Years do not match';
        year_error.value = 'Years do not match';
        return;
      }
    }
    fiscal_year_ending_on_error.value = '';
    year_error.value = '';

    if (sectionFile.value.year != year_val && year_val) {
      store.commit('updateFileById',{
        id: props.fileId, 
        updates: {
          new_year: year_val,
        }
      })
    }
    if (sectionFile.value.fiscal_year_ending_on != fiscal_year_ending_on_val && fiscal_year_ending_on_val) {
      store.commit('updateFileById',{
        id: props.fileId, 
        updates: {
          new_fiscal_year_ending_on: fiscal_year_ending_on_val,
        }
      })
    }
}

function eventClick(event) {
  event.stopPropagation();
}




function handleFileChange(event) {
  const files = event.target.files || event.dataTransfer.files;
  
  if (files.length > 0) {
    selectedFile.value = files[0];
  }
  const file = selectedFile.value;
  file.filename = file.name;
  store.commit('updateFileById',{
    id: props.fileId, 
    updates: {
      file: file,
      new_file: true,
    }
  })
}


function DeleteFileConfirm() {
  deleteObject.value = true;
}


async function popupConfirm(event){
  deleteObject.value = false;

  if (!event) {
    return
  }
  
  const result = await API.deleteObject(sectionFile.value.id, 'kyc_file', sectionFile.value.file.filename + 'file');

  if (result) {
    // store.dispatch('addNotification', {text: 'Request to delete ' + filePresentLocal.value.filename + ' has been sent', type: 'success'})
    // selectedFile.value = null;
    // filePresentLocal.value = null;
    // localFile.value = null;
  }
}

async function openFile(event) {
    await API.generateViewToken();
    event.stopPropagation();
    if (props.fileToShow && props.fileToShow[props.state]) {
      window.open(`${API.API_URL}get-kyc-file/?id=${props.fileToShow[props.state].serverName}&viewingToken=${viewingToken.value}`, '_blank');
      return;
    } else {
      window.open(`${API.API_URL}get-kyc-file/?id=${sectionFile.value.file.serverName}&viewingToken=${viewingToken.value}`, '_blank');
    }
}

async function Download(event) {
    event.stopPropagation();
    if (props.fileToShow && props.fileToShow[props.state]) {
      await API.DownloadKYCFile(props.fileToShow[props.state].serverName, props.fileToShow[props.state].filename);
      return;
    } else {
      await API.DownloadKYCFile(sectionFile.value.file.serverName, sectionFile.value.file.filename);
    }
}





</script>
<style scoped lang="scss">
  .delete {
    width: 30px;
    height: 30px;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 4px;
    bottom: 0px;
    
  }
  .options {
    input {
      width: 15px;
    }
  }
  .option-desctions {
    font-weight: bold;
    text-align: left;
    width: 150px;
  }
  .download {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    padding: 8px;
    border-radius: 4px;
    // &:hover {
    //   cursor: pointer;
    //   background-color: var(--app-background);
    //   outline: 1px solid var(--border-color);
    // }
  }
  .action-div {
    padding: 0px 4px;

  }
  .action-div:hover {
    cursor: pointer;
    background-color: var(--app-background);
    outline: 1px solid var(--border-color);
    border-radius: 4px;
  } 
  .pending-changes {
    width: 18px;
    height: 18px;
  }
  .hasChanges[class] {
    border-color: var(--primary-color);
  }
  .image-upload {
    width: 30px;
    height: 30px;
    z-index: 3;
    margin-top: 5px;
    margin-left: 5px;
  }
  .header {
    color: black;
    font-weight: 600;
    text-align: left;
    max-width: 100%;
    font-size: 14px;
    z-index: 2;
    padding-left: 5px;
    margin-bottom: 10px;
  }
  .file-name-section {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;

  }
  .upload-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding-right: 20px;
    border-radius: 5px;
    border-radius: .5rem;
    border-style: dashed;
    border-width: 2px;
    transition: all 0.3s;
    width: 100%;
    border-color: rgb(224 226 236);
    font-size: 14px;
    i {
      word-break: break-word;
    }
  }
  .drop-area {
    position: relative;
    width: 335px;
    height: fit-content;
    min-width: 300px;
    background-color: white;
    display: flex;
    align-items: flex-start;
    color: #8997A5;
  
    cursor: pointer;
    box-sizing: border-box;
    &.canUpload:hover .upload-section {
      border-color: var(--primary-color);
      font-size: 15px;
    }

  }

  .button {
    width: fit-content;
    color: var(--primary-color);
  }
.margin-top-10 {
  margin-top: 10px;
}

.input-fiscal-year {
  width: fit-content;
}
.buttons {
  height: 37px;
}
.action-buttons {
  white-space: nowrap;
}
.plus {
  width: 15px;
  height: 15px;
  margin-right: 10px;
  transform: rotateZ(45deg);
  :hover {
    background: unset;
    cursor: pointer;
  }
}
.margin-div {
  display: flex;
  gap: 10px;
  button {
    flex: 1;
  }
}

.main-section-wrapper {
  justify-content: space-between;
  display: flex;
  flex-direction: column;
}
.wrapper-of-uploade {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  justify-content: flex-end;
}

.area-width {
  width: 335px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
      margin-right: 10px;
  }
}
.structure-view[class] {
  // &:deep(.container) {
      width: 90vw;
      height: 80vh;
  // }
}
.title {
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}
.title-0.title-len2 {
  margin: 0;
}

.title-1.title-len2:not(.second_line_normal) {
  font-size: 16px;
  color: black;
}

.styled-input {
    display: flex;
    flex-direction: column;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: #3D5873;
    text-align: left;
  }
  
  input, select {
    background: #38314e;
    border: 1px solid #2b263a;
    outline: none;
    caret-color: #2b263a;
    color: white;
    padding: 3px 10px;
    border-radius: 5px;
    font-size: 16px;
    height: 22px;
    border-top: unset;
    border-left: unset;
    border-right: unset;
    border-radius: 0;
    transition: padding 0.3s;
    &.select-elem {
      width: 100%;
      height: 30px;
    }
    &:focus {
      padding-bottom: 10px;
    }
    padding-left: 0;
  }
  .light {
    background: unset;
    color: black;
    caret-color: black;
  }
  

  .error-present {
    input, select {
      border-color: red;
      border-width: 1.5px;
    }
  }
  .light_label {
    font-size: 13px;
    margin-bottom: 0;

  }
  .error {
    color: red;
    text-align: left;
    padding-left: 14px;
  }

  .full-width[class] {
    width: 100%;
  }
  .additinal-info {
    display: flex;
    gap: 30px;
    > * {
      flex: 1;
      &.date-input {
        flex: 2;
      }
    }
  }
  .more-actions {
    display: flex;
    align-items: center;
    gap: 25px;
    // margin-top: 10px;
    color: #465E8B;
    font-weight: bolder;
}

.reminder-text {
  line-height: 15px;
  margin-left: -15px;
}
.long-header[class] {
  margin-top: 32px;
}
.popup-confirm[class] {
  &:deep(.header) {
    font-size: 22px;
  }
}
.reviewMode.new {
  .change {
    background: #DEF7EC;
    &:deep(label) {
        background: #DEF7EC;
    }
  }
}
.reviewMode.current {
  .change {
    background: #FDE8E8;
    &:deep(label) {
      background: #FDE8E8;
    }
  }
}

.loader img {
  animation: rotate 1s linear infinite;
}
.loader-text {
  font-size: 18px;
  color: black;
}
@keyframes rotate {
  100% {
      transform: rotate(360deg);
  }
}
.container-loading  {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 350px;
  height: 200px;
  background-color: white;
}

.loader-header {
  font-size: 24px;
  color: black;
  font-weight: bold;
}
.sanction-screanin-response {
  height: 90vh;
  min-height: 400px;
  width: 70vw;
  overflow: auto;
  background-color: white;
  padding: 20px;
  border-radius: 0.5rem;
}

.sanction-screening-comment-popup[class] {
  width: 900px;
  height: 350px;
}
.markdown-content {
  width: 100%;
  min-height: 250px;
}
.alert {
  color: red;
  text-align: left;
}

.info-icon {
  width: 22px;
  height: 22px;
  margin-left: 5px;
  margin-top: 5px;
  cursor: pointer;
}

.p-5 {
  padding: 5px;
}

.file-button {
  color: rgb(29, 29, 29);
  font-size: 14px;
  // width: 150px;
  img {
    width: 13px;
    margin-right: 5px;
    margin-top: -2px;
  }
}
.color-white {
  color: white;
}
.current-file-section {
  display: flex;
  gap: 10px;
  background-color: #f3f5f6;
  border-radius: 5px;
  padding: 10px 0px;
  max-width: 400px;
}

.action-div {
  display: flex;
  margin-left: -5px;
  align-items: center;
  cursor: pointer;
}
.file-name {
  font-size: 14px;
  color: rgb(0, 0, 0);
  font-weight: 500;
  display: flex;
  align-items: center;
}


.file-info {
  position: relative;
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  .label-extension {
    position: absolute;
    color: white;
    font-size: 11px;
    width: 40px;
    top: 20px;
    left: 5px;
    font-weight: 600;
    text-align: center;
  }
}
.has-changes {
  position: absolute;
  right: 5px;
}
.missing-file {
  cursor: pointer;
  img {
    filter: grayscale(100%);
    opacity: 0.3;
  }
  .file-name {
    color: rgb(120, 120, 120);
  }
  &:hover {
    img {
      filter: grayscale(80%);
      opacity: 0.4;
    }
    .file-name {
      color: rgb(0, 0, 0);
    }
  }
}
.extra-buttons {
  .buttons {
    height: 30px;
  }
}
.drag-over {
  .upload-section {
    border-color: var(--primary-color);
  }
}
</style>